(() => {
  'use strict';
  if (window.cardclubHeaderRegionStarted) return;
  window.cardclubHeaderRegionStarted = true;
  const scope = '[data-cc-header-region]';

  // Reject ambiguous slash/escape forms, including recursively encoded redirects.
  // Retain ordinary escaped product handles; never accept an external return URL.
  const safePath = path => {
    let decoded = path;
    for (let pass = 0; pass < 5; pass += 1) {
      if (!decoded.startsWith('/') || decoded.startsWith('//') || /[\\\u0000-\u001f\u007f]/.test(decoded)) return false;
      let next;
      try { next = decodeURIComponent(decoded); } catch { return false; }
      if (next === decoded) return true;
      decoded = next;
    }
    return false;
  };

  const returnPath = region => {
    let records;
    try { records = JSON.parse(region.querySelector('[data-cc-region-routes]').textContent); } catch { return '/'; }
    if (!records || typeof records !== 'object') return '/';
    const url = new URL(window.location.href);
    if (url.origin !== window.location.origin || !safePath(url.pathname)) return '/';
    const roots = [records.root, ...(Array.isArray(records.localeRoots) ? records.localeRoots : [])]
      .filter(root => typeof root === 'string' && safePath(root) && root !== '/')
      .map(root => root.replace(/\/$/, ''))
      .sort((a, b) => b.length - a.length);
    // Match an entire rendered prefix, never the ISO code guessed from a locale.
    const root = roots.find(prefix => url.pathname === prefix || url.pathname.startsWith(prefix + '/'));
    const path = root ? url.pathname.slice(root.length) || '/' : url.pathname;
    if (!safePath(path)) return '/';
    // Preserve raw query encoding, order, duplicate variant/UTM keys, and the hash.
    const query = url.search.slice(1).split('&').filter(part => {
      let key;
      try { key = decodeURIComponent(part.split('=', 1)[0].replace(/\+/g, ' ')).toLowerCase(); } catch { return true; }
      return key !== 'country' && key !== 'locale';
    }).join('&');
    return path + (query ? '?' + query : '') + url.hash;
  };

  const prepare = form => {
    if (!(form instanceof HTMLFormElement)) return false;
    const region = form.closest(scope);
    const select = form.querySelector('[data-cc-region-country]');
    const option = select?.selectedOptions[0];
    const language = form.elements.namedItem('language_code');
    const back = form.elements.namedItem('return_to');
    if (!region || !option || option.disabled || !language || !back) return false;
    const available = (option.dataset.languages || '').split(',').filter(Boolean);
    // Region selection changes delivery context, not presentation language.
    // Preserve a supported manual language; English is the server-rendered default.
    const nextLanguage = available.includes(region.dataset.language) ? region.dataset.language : option.dataset.language;
    if (!/^[A-Z]{2}$/.test(option.value) || !available.includes(nextLanguage)) return false;
    let action;
    try { action = new URL(form.action, window.location.href); } catch { return false; }
    if (action.origin !== window.location.origin || !/\/localization\/?$/.test(action.pathname) || form.method.toLowerCase() !== 'post') return false;
    language.value = nextLanguage;
    back.value = returnPath(region);
    return true;
  };

  // Delegation also covers newly rendered sections. Re-running this asset is inert.
  document.addEventListener('change', event => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.matches(`${scope} [data-cc-region-country]`)) return;
    if (!prepare(select.form)) return;
    if (typeof select.form.requestSubmit === 'function') select.form.requestSubmit();
    else HTMLFormElement.prototype.submit.call(select.form);
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches(`${scope} .cc-header-region__form`)) return;
    if (!prepare(form)) event.preventDefault();
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const region = event.target.closest?.(`${scope}[open]`);
    if (!region) return;
    region.open = false;
    region.querySelector('summary').focus();
  });
  document.addEventListener('click', event => {
    document.querySelectorAll(`${scope}[open]`).forEach(region => {
      if (!region.contains(event.target)) region.open = false;
    });
  });
})();
